export const medinaceli = {
	nombre: "Medinaceli",
	dia: "Jueves Santo",
	nombrecompleto:
		"Hermandad Sacramental, Esclavitud y Cofradía de Penitencia de Nuestro Padre Jesús Cautivo y Rescatado y María Santísima de la Trinidad (Vulgo Medinaceli)",
	sede: "Parroquia de Santa Cruz (Antigua Catedral)",
	pasos: 2,
	distancia: [1070, 1460],
	penitentes: 150,
	cargadores: 108,
	web: "http://www.diariodecadiz.es/semana_santa/Medinaceli_0_1229577729.html",

	ida: [
		{ lng: -6.29444, lat: 36.52858 },
		{ lng: -6.2944311, lat: 36.528588 },
		{ lng: -6.2943976, lat: 36.528629 },
		{ lng: -6.2942702, lat: 36.5285708 },
		{ lng: -6.2942205, lat: 36.5288165 },
		{ lng: -6.2941924, lat: 36.5288445 },
		{ lng: -6.2941065, lat: 36.5291732 },
		{ lng: -6.2938531, lat: 36.529143 },
		{ lng: -6.2938115, lat: 36.5292012 },
		{ lng: -6.2932952, lat: 36.5291376 },
		{ lng: -6.2932388, lat: 36.5293887 },
		{ lng: -6.2933998, lat: 36.5294124 },
		{ lng: -6.2933287, lat: 36.5297303 },
		{ lng: -6.2936385, lat: 36.5297012 },
		{ lng: -6.2938169, lat: 36.5297001 },
		{ lng: -6.294588, lat: 36.5296247 },
		{ lng: -6.2944029, lat: 36.5303651 },
		{ lng: -6.2943426, lat: 36.5305536 },
		{ lng: -6.2940502, lat: 36.5305795 },
		{ lng: -6.2935004, lat: 36.5307411 },
		{ lng: -6.292921, lat: 36.5310741 },
		{ lng: -6.2922196, lat: 36.5302939 },
		{ lng: -6.2928191, lat: 36.5297928 },
		{ lng: -6.293043, lat: 36.5298208 },
		{ lng: -6.2933408, lat: 36.5297454 },
		{ lng: -6.2936425, lat: 36.5297174 },
		{ lng: -6.2938195, lat: 36.5297152 },
		{ lng: -6.2945464, lat: 36.5296441 },
		{ lng: -6.294619, lat: 36.5295604 },
		{ lng: -6.2948777, lat: 36.5296193 },
		{ lng: -6.2950855, lat: 36.5296247 },
		// CATEDRAL
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		// CATEDRAL
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.295689, lat: 36.5291074 },
		{ lng: -6.2955187, lat: 36.5295665 },
		{ lng: -6.2954128, lat: 36.5297659 },
		{ lng: -6.2956689, lat: 36.5299523 },
		{ lng: -6.2952834, lat: 36.5303564 },
		{ lng: -6.2950212, lat: 36.5308403 },
		{ lng: -6.2949005, lat: 36.5308446 },
		{ lng: -6.2949219, lat: 36.5314524 },
		{ lng: -6.29563, lat: 36.5316108 },
		{ lng: -6.2964629, lat: 36.5317735 },
		{ lng: -6.2964106, lat: 36.53185 },
		{ lng: -6.2965728, lat: 36.5321216 },
		{ lng: -6.2967834, lat: 36.5325505 },
		{ lng: -6.2972528, lat: 36.5319373 },
		{ lng: -6.2975693, lat: 36.5310073 },
		{ lng: -6.2970972, lat: 36.5308812 },
		{ lng: -6.2967237, lat: 36.5308349 },
		{ lng: -6.2963093, lat: 36.5305897 },
		{ lng: -6.2956864, lat: 36.5299308 },
		{ lng: -6.2953055, lat: 36.5296506 },
		{ lng: -6.2950292, lat: 36.5295967 },
		{ lng: -6.2948817, lat: 36.5295945 },
		{ lng: -6.2946054, lat: 36.5295385 },
		{ lng: -6.294533, lat: 36.5296118 },
		{ lng: -6.2938115, lat: 36.5296829 },
		{ lng: -6.2935795, lat: 36.5296807 },
		{ lng: -6.2931583, lat: 36.5297298 },
		{ lng: -6.2932006, lat: 36.5295003 },
		{ lng: -6.2932456, lat: 36.5293009 },
		{ lng: -6.2932811, lat: 36.5291179 },
		{ lng: -6.2938001, lat: 36.5291825 },
		{ lng: -6.293839, lat: 36.5291296 },
		{ lng: -6.2940918, lat: 36.5291559 },
		{ lng: -6.2941719, lat: 36.528841 },
		{ lng: -6.2942013, lat: 36.5288133 },
		{ lng: -6.2942589, lat: 36.5285425 },
		{ lng: -6.2943882, lat: 36.5286059 },
		{ lng: -6.294417, lat: 36.5285723 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-29T22:35",
			latlng: [36.52857, -6.29444]
		},
		{
			name: "Nueva",
			hora: "2018-03-30T00:40",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-30T01:40",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-30T02:40",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-30T03:05",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-30T03:15",
			latlng: [36.53254, -6.29679]
		}
	],
	itinerario: [
		[
			"Jesus de Medinaceli",
			"Plaza de Fray Félix",
			"Obispo Jose María Rances",
			"Plaza San Martin",
			"Posadilla",
			"San Antonio Abad",
			"Fabio Rufino",
			"Pomponio Mela",
			"Pelota",
			"Cobos",
			"Cristobal Colon",
			"Nueva"
		],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pio XII",
			"Estación de Penitencia en la S.I.C."
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañes", "Palillero"],
		["Novena", "Barrié"],
		[
			"Plaza Topete",
			"Compañía",
			"Plaza Pio XII",
			"Pelota",
			"San Antonio Abad",
			"Posadilla",
			"Plaza de San Martín",
			"Obispo José María Rancés",
			"Plaza de Fray Félix",
			"Jesus de Medinaceli"
		]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/medinaceli.js